import React from 'react';
import Lottie, { Options } from 'react-lottie';
import animationData from '../animation/upcoming.json';

const defaultOptions: Options = {
	loop: true,
	autoplay: true,
	animationData: animationData,
	rendererSettings: {
		preserveAspectRatio: 'xMidYMid slice',
	},
};

const Upcoming: React.FC = () => {
	return (
		<div className="mt-[100px] flex items-center justify-center">
			<Lottie
				options={defaultOptions}
				width={700}
				ariaLabel="Upcoming Animation"
				title="Upcoming Animation"
			/>
		</div>
	);
};

export default Upcoming;
